//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PRICING from 'src/resources/pricing.hjson';

export default {
	name: 'PricingBox',

	data: () => ({
		pricing: PRICING,
	}),

	props: {
		name: {
			type: String,
			required: true,
		},
		price: {
			type: [String, Number],
			required: true,
		},
		period: {
			type: String,
			required: true,
		},
		hightlight: {
			type: Boolean,
			required: false,
		},
	},

	methods: {
		select() {
			this.$emit('select', this.name);
		},
	},
};
